import $ from 'jquery';

let showAndHideTopBar = () => {
  $(window).on('scroll', function() {
    let scrollVal = $(this).scrollTop();
    if(scrollVal > 450 && !$("#top-bar").hasClass('isScrolling')){
      $("#top-bar").addClass('isScrolling');
      $("#top-bar").removeClass('isScrollingTop');
    }
    else if(scrollVal < 450 && $("#top-bar").hasClass('isScrolling')){
      $("#top-bar").removeClass('isScrolling');
      $("#top-bar").addClass('isScrollingTop');
    }
  });
}
showAndHideTopBar();